module.exports = __webpack_public_path__ + "static/media/DJ.4042c091.png";